export default __webpack_public_path__ + "static/media/walk-icon.48fd172f.svg";